import { Autocomplete, InputAdornment, TextField } from "@mui/material";
import { forwardRef, MouseEventHandler, useEffect, useRef, useState } from "react";
import { PlusIcon, SearchIcon } from "../../assets/icons";
import { MealBriefResponse, AdminMealMultiLangResponse } from "../../openapi/client";
import theme from "../../theme";

interface IProps {
  meals: MealBriefResponse[];
  onChange: (event: MouseEvent, newValue: MealBriefResponse | null) => void;
}

const TextSearch = forwardRef((props: IProps, ref) => {
  const inputRef = useRef<HTMLInputElement>();
  const [mealValue, setMealValue] = useState<MealBriefResponse | null>(null);
  const [inputValue, setInputValue] = useState("");

  const handleOnchange = (event: any, newValue: MealBriefResponse | null) => {
    event.stopPropagation();
    props.onChange(event, newValue);
    inputRef.current?.focus();
    setInputValue("");
  };

  const handleOnInputChange = (event: React.SyntheticEvent, value: string, reason: string) => {
    setInputValue(value);
  };

  return (
    <Autocomplete
      {...props}
      ref={ref}
      sx={{
        "& .MuiInputBase-root": { height: "30px", margin: 0, bgcolor: "#fff" },
        "& .MuiAutocomplete-input": {
          paddingTop: "0 !important",
          paddingBottom: "0 !important",
          color: "text.dark2",
          fontSize: "14px",
          fontStyle: "normal",
          fontWeight: 500,
        },
        "& .MuiOutlinedInput-notchedOutline": {
          borderRadius: "8px",
          borderColor: "#e5e7ea !important",
        },
        "& .MuiOutlinedInput-root": {
          padding: 0,
          paddingLeft: "3px",
        },
        "& .MuiInputAdornment-root": {
          marginRight: 0,
        },
      }}
      value={mealValue}
      inputValue={inputValue}
      options={props.meals}
      onChange={handleOnchange}
      onInputChange={handleOnInputChange}
      getOptionLabel={(option) => String(option.name)}
      renderOption={(props, option) => {
        return (
          <li {...props} key={option.id}>
            {option.name}
          </li>
        );
      }}
      renderInput={(params: any) => (
        <TextField
          {...params}
          inputRef={inputRef}
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <InputAdornment position="start">
                <PlusIcon color={theme.palette.primary.main} />
              </InputAdornment>
            ),
          }}
          placeholder="Search meal name"
        />
      )}
    />
  );
});

export default TextSearch;
